<template>
	<div>
		<div class="container">
			<loginHeader :lang="lang"></loginHeader>

				<div class="home-login" style="height: 699px;">
					<div class="home-text0" >
						<p class="one">酒店及自<span>游</span>行</p>
						<p class="two">产品交易平台</p>
					</div>
					<div class="home-box home-lf home-login-hack">
						<form class="home-login-form" @submit.prevent="login" autocomplete="on">
							<div class="home-lf-sys-a" style="">
								<a href="http://ebooking.cnbooking.net">供应商操作系统</a>
								<i>>></i>
							</div>
							<ul class="home-lf-box">
								<li>
									<h1>企业用户登录 </h1>
								</li>
								<li>
									<input name="CustomerNO" type="text"  maxlength="10" class="L-input-large" tabindex="1" placeholder="企业编号" aria-label="企业编号" autocomplete="off" data-lpignore="true" v-model="CustomerNO"  />
								</li>
								<li>
									<input name="Oper" type="text" maxlength="10" class="L-input-large" tabindex="2" placeholder="操作员" aria-label="操作员" autocomplete="username" v-model="Oper" />
								</li>
								<li>
									<input name="password" type="password"  maxlength="20" class="L-input-large" tabindex="3" placeholder="密码" aria-label="密码" autocomplete="current-password" v-model="Pwd" />
								</li>
								<li>
									<input name="captchaCode" type="text"  maxlength="4" class="L-input-large" tabindex="4" placeholder="验证码" aria-label="验证码" autocomplete="off" data-lpignore="true" v-model="captchaCode" />
									<img :src="codeImg" class="log-code" @click="getCaptcha" />
								</li>
								<li style="margin-bottom: 0px;">
									<button type="submit" class="home-submit cursorPoint" style="border: none;">登录</button>
							
									
								</li>
								<li style="margin-bottom: 0px; height: 23px;">
									<label for="ckSaveAccount" class="home-btn-save">
										<input name="ckSaveAccount" type="checkbox" v-model="isCheck" tabindex="5"/>
										记住账号密码
									</label>
									<a class="home-btn-forget" @click="forgetPassword">忘记密码</a>
									<router-link to="register" class="home-btn-forget">我要注册</router-link>
								</li>
							</ul>
						</form>
					</div>
				</div>
			</div>
			<div class="home-cnBg">
				<div class="cnBg">
					<p class="title titlel">没有订房难，只有<span>订房易</span></p>
					<p class="text">你想要的这都有</p>
				</div>
			</div>
			<div class="home-info home-info-f8" >
				<div class="home-info-list">
					<div class="home-box content-box">
						<transition name="icon1">
							<div :class="['icon-icon icon1', {'slideInLeft': iconShow1, 'iconHide': !iconShow1}]"></div>
						</transition>
						<div class="home-text">
							<p class="title title2">全球酒店预订资源</p>
							<p class="text">每天大量中、港、澳及海外包房酒店促销优惠!</p>
							<p class="text">40万家港澳及国内酒店可供预订！超过60万家海</p>
							<p class="text">外酒店预订资源！15万家酒店可实时确认!</p>
						</div>
					</div>
				</div>
			</div>


			<div class="home-info home-info-fff" >
				<div class="home-info-list">
					<div class="home-box content-box">
						<div class="home-text">
							<p class="title title3">实时预订 实时确认</p>
							<p class="text">集产品、预订、支付、财务内部管理功能为一体。</p>
						</div>
						<transition name="icon2">
							<div :class="['icon-icon icon2', {'slideInRight': iconShow2, 'iconHide': !iconShow2}]"></div>
						</transition>
					</div>
				</div>
			</div>

			<div class="clear"></div>
			<div class="home-info home-info-f8" >
				<div class="home-info-list">
					<div class="home-box content-box">
						<transition name="icon1">
							<div :class="['icon-icon icon3', {'slideInLeft': iconShow3, 'iconHide': !iconShow3}]"></div>
						</transition>
						<div class="home-text">
							<p class="title title4" style="height: 68px;">数据对接 方便快捷</p>
							<p class="text">订房易提供标准化API数据接口，实时获取价格、库存，实</p>
							<p class="text">时下单实时成交。接口中提供海量产品，互联网旅游生态，</p>
							<p class="text">无缝对接，大量节约人力，提升效率。</p>
						</div>  
					</div>
				</div>
			</div>

			<div class="clear"></div>
			<div class="home-info home-info-fff" >
				<div class="home-info-list">
					<div class="home-box content-box">
						<div class="home-text">
							<p class="title title5" style="height: 68px;">信贷支持 财务无忧</p>
							<p class="text">您的生意伙伴，专享免息信用结算，龙腾捷旅强大的资金储备</p>
							<p class="text">为您的业务保驾护航，只为您用得更好，订的更顺。</p>
						</div>
						<transition name="icon2">
							<div :class="['icon-icon icon4', {'slideInRight': iconShow4, 'iconHide': !iconShow4}]"></div>
						</transition>
					</div>
				</div>
			</div>
	
			<div class="clear"></div>
			<div class="home-footer">
				<div class="home-box home-footer-t">
					<div class="top">
						<div class="left home-contact">
							<h3>了解我们</h3>
							<router-link to="about">关于我们</router-link>
							<router-link to="contact">联系我们</router-link>
							<router-link to="contact">投诉建议</router-link>
							<router-link to="join">诚聘英才</router-link>
							
						</div>
						<div class="middle home-contact">
							<h3>客户须知</h3>
							<router-link to="introduction">预订须知</router-link>
							<router-link to="introduction">协议下载</router-link>
							<router-link to="introduction">教程下载</router-link>
						</div>
						<div class="right home-contact">
							<h3>邮箱地址</h3>
							<a href="#">国内酒店合作 chinahotel-1@cnbooking.net</a>
						<a href="#">国际酒店合作 globalhotel-33@cnbooking.net</a>
						<a href="#">OTA合作 channel-3@cnbooking.net</a>
						<a href="#">旅行社合作 chinahotel-3@cnbooking.net</a>
						</div>
						<div class="right-side home-contact">
							<h3>微信二维码</h3>
							<img src="./../assets/img/ewm.png" alt="" />
						</div>
						<div class="clear"></div>
					</div>
					<div class="bottom">
						<img src="./../assets/img/home-footer-logo.png" alt="" />
						<div>
							<h4>Copyright©2013-2017,dingfangyi.com.All rights reserved.</h4>
							<h4>
								<a target="_blank" href="http://beian.miit.gov.cn"style="text-decoration: none; color: #999;">粤ICP备17131089号</a>
								<a target="_blank" href="http://beian.miit.gov.cn" style="text-decoration: none; color: #999; float: right;">
									<img src="./../assets/img/ga.png" />
									    粤公网安备 44030302000423号
								</a>
							</h4>
						</div>
					</div>
				</div>
			</div>
			<transition name="footer">
				<div class="footer-fixed"  v-show="isFooterShow">
        			<div class="footer-mask"></div>
        			<div class="footer-fixed-content">
            			<div class="close" @click="isFooterShow = false;isFooterAsideShow = true"></div>
						<div style="background-image:url(/static/img/00.7c552be.png);background-position:-107px 326px;width: 317px;height:633px;position: absolute;top: -114px;display: inline-block;"></div>
						<div style="background-image:url(/static/img/00.7c552be.png);background-position: -471px 208px;width: 675px;height: 200px;position: absolute;top: 15px;display: inline-block;left: 400px;"></div>
        			</div>
    			</div>
    		</transition>
    		<transition name="aside">
    			<div class="aside-fixed" v-show="isFooterAsideShow" @click="isFooterShow = true;isFooterAsideShow = false"></div>
    		</transition>
	</div>
	
	 
</template>
<script>
import loginHeader from "./loginHeader"; //头部

export default {
  components: {
    loginHeader
  },
  name: "Login",
  data() {
    return {
      isCheck: true,
      languageShow: false,
      CustomerNO: "",
      Oper: "",
      Pwd: "",
      codeImg: "",
      captcha: "",
      captchaCode: "",
      isFooterAsideShow: false,
      isFooterShow: true,
      iconShow1: false,
      iconShow2: false,
      iconShow3: false,
      iconShow4: false,
			lang:''
    };
  },
  methods: {
    changeLang() {
      window.location.href = "http://en.dingfangyi.com/";
    },
    getCaptcha() {
      var that = this;
      var params = {
        width: "300",
        height: "200"
      };
      that
        .getRequest({
          url: that.Api.captcha,
          params: params
        })
        .then(res => {
          that.codeImg = "data:image/jpg;base64," + res.Img;
          that.captcha = res;
          // if (res && res.IsSuccess) {
          //     that.keyResult = res.Result;
          // }
        });
    },
    forgetPassword() {
      this.error({ title: "提示", content: "请咨询电话: 0755-82318709" });
    },
    login() {
      var that = this;
			// 兜底：防止密码管理器填充后 v-model 未同步
			var form = that.$el.querySelector('.home-login-form');
			if (form) {
				that.CustomerNO  = form.querySelector('[name=CustomerNO]').value;
				that.Oper        = form.querySelector('[name=Oper]').value;
				that.Pwd         = form.querySelector('[name=password]').value;
				that.captchaCode = form.querySelector('[name=captchaCode]').value;
			}

      if (!that.CustomerNO) {
        that.error({ title: "提示", content: "请填写企业编号！" });
        return;
      }
      if (!that.Oper) {
        that.error({ title: "提示", content: "请填写操作员！" });
        return;
      }
      if (!that.Pwd) {
        that.error({ title: "提示", content: "请填写密码！" });
        return;
      }
      if (!that.captchaCode) {
        that.error({ title: "提示", content: "请填写验证码！" });
        return;
      }
      var data = {
        CustomerNO: that.CustomerNO,
        Oper: that.Oper,
        Pwd: that.Pwd,
        CaptchaCode: that.captchaCode,
        CaptchaToken: that.captcha.Token,
        CaptchaTrackeKey: that.captcha.TraceKey
      };
      var loginInfo = {
        CustomerNO: that.CustomerNO,
        Oper: that.Oper,
        Pwd: that.Pwd
      };
      that
        .postRequest({
          url: that.Api.login,
          params: data
        })
        .then(res => {
          if (res && res.IsSuccess) {
            //登陆成功后，保存登陆信息到本地localstorage
            that.dao.set("userInfo", res.Result);

            that.setHttpHeaders(res.Result.AccessToken);
            if (that.isCheck) {
              that.dao.set("loginInfo", loginInfo);
            } else {
              that.dao.set("loginInfo", "");
            }
            that.$router.push("/");
          } else {
            that.getCaptcha();
            that.error({
              title: "提示",
              content: res.Msg || "登录出错，请重试！"
            });
          }
        });
    },
    pageScroll() {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      var top1 = document.getElementsByClassName("home-info")[0].offsetTop;
      var top2 = document.getElementsByClassName("home-info")[1].offsetTop;
      var top3 = document.getElementsByClassName("home-info")[2].offsetTop;
      var top4 = document.getElementsByClassName("home-info")[3].offsetTop;
      if (scrollTop > top1 - 450) {
        this.iconShow1 = true;
      }
      if (scrollTop > top2 - 450) {
        this.iconShow2 = true;
      }
      if (scrollTop > top3 - 450) {
        this.iconShow3 = true;
      }
      if (scrollTop > top4 - 450) {
        this.iconShow4 = true;
      }
    }
  },
  mounted() {
    this.getCaptcha();
    document.title =
      "以酒店预订为核心的自游行产品交易平台,订房易,香港酒店,澳门酒店,国内酒店,海外酒店,门票预订,自由行预订";
    window.addEventListener("scroll", this.pageScroll);
    var currentScreenHeight = window.innerHeight;
    document.getElementsByClassName("home-login")[0].style.height =
      currentScreenHeight - 320 + "px";
  },
  destroyed() {
    window.removeEventListener("scroll", this.pageScroll);
  },
  created() {
		if(this.$route.query.lang){
			this.lang = this.$route.query.lang
		}
    var loginInfo = this.dao.get("loginInfo") || "";
    if (loginInfo) {
      this.CustomerNO = loginInfo.CustomerNO;
      this.Oper = loginInfo.Oper;
      this.Pwd = loginInfo.Pwd;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue